import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { SwiperClass } from '../Swiper';
//import { getImageUrl } from '../../helpers/images';
//import { useGlobalContext } from '../../stores/global';
import styles from './PropertyNoBimmo.module.scss';
import { getFormattedPrice } from '../../helpers/price';
import { getSingularPluralWord } from '../../i18n/translations';
import { Tooltip } from '@mui/material';
import resizeBlack from '../../images/icons/resizeBlack.svg';
import resize from '../../images/icons/resize.svg';
import NoImage from '../../images/noimage-placeholder.png';
import casaDefault from '../../images/casaDefault.jpg';
import apartamentoDefault from '../../images/apartamentoDefault.jpg';
import loteDefault from '../../images/loteDefault.jpg';
import edificioDefault from '../../images/edificioDefault.jpg';
import localDefault from '../../images/localDefault.jpg';
import apartaestudioDefault from '../../images/apartaestudioDefault.jpg';
import oficinaDefault from '../../images/oficinaDefatult.jpg';
import consultorioDefault from '../../images/consultorioDefault.jpg';
import { useGlobalContext } from '../../stores/global';
import moment from 'moment';

interface Props {
  property: any;
  onFavorite?: (isFavorite: boolean) => void;
  type?: 'mapinfo';
  avgPrices: any;
  onTouchStart?: (
    swiper: SwiperClass,
    event: MouseEvent | TouchEvent | PointerEvent
  ) => void | undefined;
}

export function PropertyNoBimmo({
  property,
  //onFavorite,
  type,
  avgPrices,
}: //onTouchStart,
Props) {
  //const [slide, setSlide] = useState(0);
  //const [isFavorite, setFavorite] = useState(false);
  //const { dispatch } = useGlobalContext();
  const { user, dispatch } = useGlobalContext();
  useEffect(() => {
    //setFavorite(property.favorite);
  }, []);

  /* const handleFavorite = () => {
    favorite(property._id)
      .then((response) => {
        const newIsFavorite = !!response.data.data.added;
        setFavorite(newIsFavorite);
        onFavorite?.(newIsFavorite);
      })
      .catch(openSigninOn401Error.bind(null, dispatch));
  };

  if (!property?.id) return null; */

  /*const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };*/

  const [iconImg, seticonImg] = useState(false);

  const goToLink = () => {
    let count = parseInt(localStorage.getItem('countTimesClick') || '0');
    if (count > 2 && !user?.name) {
      dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signin' });
    } else {
      localStorage.setItem('countTimesClick', (count + 1).toString());
      window.open(property.link, '_blank');
    }
  };

  const goToDetail = () => {
    let count = parseInt(localStorage.getItem('countTimesClick') || '0');
    if (count > 2 && !user?.name) {
      dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signin' });
    } else {
      localStorage.setItem('countTimesClick', (count + 1).toString());
      window.open(`/inmueble/${property.id}`, '_blank');
    }
  };

  const getAvgPriceNumber = (neighborhood: string, propertyType: string) => {
    // Cuadrar para tildes
    let res = avgPrices.filter((item: any) => {
      if (item._id.neighborhood && item._id.propertyType) {
        return (
          item._id?.neighborhood
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') ===
            neighborhood
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '') &&
          item._id?.propertyType
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '') ===
            propertyType
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
        );
      }
    });
    return res[0]?.avg.toFixed(2) || 0;
  };

  const getResultAnalitics = (priceMtsSq: number, avgMtsSq: number) => {
    if (priceMtsSq - avgMtsSq > 1) {
      let percent = ((priceMtsSq / avgMtsSq) * 100 - 100).toFixed(1);
      return `Precio <span class=${
        user?.name ? styles.showTextBad : styles.blurInformationBad
      }>${
        user?.name ? percent : 0
      }% </span> <span style="color:red;">mayor</span> que el precio promedio en ${
        property.neighborhood
      }`;
    } else {
      if (priceMtsSq - avgMtsSq < -1) {
        let percent = ((avgMtsSq / priceMtsSq) * 100 - 100).toFixed(1);
        return `Precio <span class=${
          user?.name ? styles.showTextBest : styles.blurInformationBest
        }>${
          user?.name ? percent : 0
        }% </span>  <span style="color:green;">menor</span> que el precio promedio en ${
          property.neighborhood
        }`;
      } else {
        return `Precio en promedio del barrio ${property.neighborhood}`;
      }
    }
  };

  const dateInSpanish = (date: string) => {
    var localLocale = moment(date);
    moment.locale('es');
    localLocale.locale(false);
    return localLocale.fromNow();
  };

  return (
    <div
      className={
        styles.container + (type === 'mapinfo' ? ` ${styles.mapInfo}` : '')
      }
      onClick={() => goToDetail()}
    >
      <span className={styles.swiperContainer}>
        <span className={styles.badget}>
          {dateInSpanish(
            property?.dates?.created
              ? property?.dates?.created
              : property.createdAt
          )}
        </span>
        {property?.isProject && (
          <span className={styles.isProject}>Nuevo proyecto</span>
        )}

        <img
          className={styles.loadingImageImg}
          src={
            property.propertyType === 'Casa'
              ? casaDefault
              : property.propertyType === 'Apartamento'
              ? apartamentoDefault
              : property.propertyType === 'Lote'
              ? loteDefault
              : property.propertyType === 'Edificio'
              ? edificioDefault
              : property.propertyType === 'Local'
              ? localDefault
              : property.propertyType === 'Apartaestudio'
              ? apartaestudioDefault
              : property.propertyType === 'Oficina'
              ? oficinaDefault
              : property.propertyType === 'Consultorio'
              ? consultorioDefault
              : NoImage
          }
          alt="No image"
        />
        {/* <a className={styles.favorite}>
          {isFavorite ? (
            <i className="fonticons fonticons-heart-filled" />
          ) : (
            <i className="fonticons fonticons-heart" />
          )}
        </Link> */}
      </span>
      <span className={clsx(styles.info, styles.title)}>
        <Tooltip title={property.title}>
          <span className={clsx(styles.shortText)}>{property.title}</span>
        </Tooltip>
      </span>
      <span className={styles.info}>
        <i className="fonticons fonticons-pin" /> &nbsp;
        <Tooltip title={property.city + ` | ` + property.neighborhood}>
          <span className={clsx(styles.address, styles.shortText)}>
            {property.city + ` | ` + property.neighborhood}
          </span>
        </Tooltip>
      </span>
      <span className={clsx(styles.info, styles.subtitle)}>
        {getFormattedPrice(property.price)}
      </span>
      <span className={clsx(styles.info)}>
        {getFormattedPrice(
          (
            parseFloat(property.price) /
            parseFloat(
              property.areaBuild > property.area
                ? property.areaBuild
                : property.area
            )
          ).toFixed(0)
        ).replace('$', '') + ' '}
        $/m²<span>&nbsp;|&nbsp;</span>
        {property.rooms === 'Sin especificar' ? '-' : property.rooms}
        <span>&nbsp;</span>
        <span style={{ textTransform: 'capitalize' }}>
          {getSingularPluralWord('room', property.rooms)}
        </span>
        <span>&nbsp;|&nbsp;</span>
        {property.bathrooms === 'Sin especificar'
          ? '-'
          : property.bathrooms}{' '}
        <span>&nbsp;</span>
        <span style={{ textTransform: 'capitalize' }}>
          {getSingularPluralWord('bathroom', property.bathrooms)}
        </span>
        <span>&nbsp;|&nbsp;</span>
        {property.areaBuild > property.area
          ? property.areaBuild
          : property.area}{' '}
        m²
      </span>
      {!user?.name ? (
        <Tooltip title={'Inicia sesión para ver toda la información'}>
          <div
            dangerouslySetInnerHTML={{
              __html: getResultAnalitics(
                parseFloat(property.price) /
                  parseFloat(
                    property.areaBuild > property.area
                      ? property.areaBuild
                      : property.area
                  ),
                getAvgPriceNumber(property.neighborhood, property.propertyType)
              ),
            }}
          ></div>
        </Tooltip>
      ) : (
        <div
          dangerouslySetInnerHTML={{
            __html: getResultAnalitics(
              parseFloat(property.price) /
                parseFloat(
                  property.areaBuild > property.area
                    ? property.areaBuild
                    : property.area
                ),
              getAvgPriceNumber(property.neighborhood, property.propertyType)
            ),
          }}
        ></div>
      )}

      <div style={{ marginTop: '15px' }}>
        <span
          onClick={() => goToLink()}
          onMouseEnter={() => seticonImg(true)}
          onMouseLeave={() => seticonImg(false)}
          className={styles.linkBlank}
        >
          {iconImg ? (
            <img className={styles.icon} src={resize} />
          ) : (
            <img className={styles.icon} src={resizeBlack} />
          )}
          {new URL(property.link).hostname
            .replace('www.', '')
            .split('.')[0]
            .toUpperCase()}{' '}
        </span>
      </div>
    </div>
  );
}
